import posthog from "posthog-js";

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(
      'phc_a6ISrQX6A837vX6PMtnorOx3aNvdvtgbxZi75otWlCB',
      {
        api_host: 'https://eu.i.posthog.com',
      }
    );
  },
};